// extracted by mini-css-extract-plugin
export default {"root":"Tooltip_root__uc0Fc","title":"Tooltip_title__ZRTgx","content":"Tooltip_content__DXSyZ","contentItem":"Tooltip_contentItem__FvRGE"};